import { render, staticRenderFns } from "./serviceCategory.vue?vue&type=template&id=05d160a4&"
import script from "./serviceCategory.vue?vue&type=script&lang=js&"
export * from "./serviceCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "serviceCategory.vue"
export default component.exports